export default "__VITE_ASSET__PIrbhcdD__"